import React from "react";
import { STSearchWrapper, STIconWrapper, STInputBase, STSearchIcon } from "./styles";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { Values } from "@src/Tools/Values";
import { ISearchStore } from "@src/Stores/Search/types";
import debounce from "lodash/debounce";
import ClearIcon from "@material-ui/icons/Clear";
import IconButton from "@material-ui/core/IconButton";

interface IProps {
  search?: ISearchStore;
}

@inject("search", "themes")
@observer
export default class GlobalSearchField extends React.Component<IProps> {
  @observable showSearch: boolean = false;

  constructor(props: IProps) {
    super(props);
    this.handleFilter = debounce(this.handleFilter, 500);
  }

  handleChange = (e: any) => {
    this.props.search.setSearchString(e.currentTarget.value);

    if (
      e.currentTarget.value.length === 1 &&
      !this.props.search.entitiesLoaded
    ) {
      this.props.search.loadAllEntities();
    }

    this.handleFilter();
  };

  handleCloseSearch = () => {
    this.props.search.setSearchString("");
    this.props.search.toggleSearch();
  };

  handleFilter = () => this.props.search.filterByAllEntities();

  render() {
    if (this.props.search.searchFieldOpened) {
      return (
        <STSearchWrapper>
          <STIconWrapper onClick={this.handleCloseSearch}>
            <ClearIcon />
          </STIconWrapper>
          <STInputBase
            onChange={this.handleChange}
            autoFocus
            value={this.props.search.searchString}
            placeholder={Values.getLocalizationValue("search")}
          />
        </STSearchWrapper>
      );
    }
    return (
      <IconButton onClick={this.props.search.toggleSearch}>
        <STSearchIcon />
      </IconButton>
    );
  }
}
